import React from "react";
import "./GuestCheckoutModal.css";

const GuestCheckoutModal = ({ isOpen, onClose, onContinueGuest, onLogin }) => {
  if (!isOpen) return null;

  return (
    <div className="checkout-modal-overlay">
      <div className="checkout-modal" style={{ maxWidth: "420px" }}>
        <div className="checkout-modal-top modal-top">
          <div></div>
          <button
            className="add-to-cart-button close-modal-button"
            onClick={onClose}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <p style={{ lineHeight: "1.6", marginTop: "30px", color: "#000" }}>
          Sign up to track orders, reorder fast, and get promo updates.
        </p>

        <div className="auth-buttons" style={{ display: "flex", gap: "10px", marginTop: "28px", marginBottom: "10px", flexWrap: "wrap" }}>
          <button
            className="add-to-cart-button auth-button"
            onClick={onLogin}
          >
            Login / Sign Up
          </button>

          <button
            className="add-to-cart-button auth-button"
            onClick={onContinueGuest}
            style={{ background: "#f3f3f3", color: "#000" }}
          >
            Continue as guest
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuestCheckoutModal;